import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputComponent } from '../../common/components/form-components/input/input';
import { Dropdown } from '../../common/components/form-components/dropdown/dropdown';
import { CardModule } from 'primeng/card';
import { Button } from '../../common/components/form-components/button/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-team',
  imports: [FormsModule, ReactiveFormsModule, InputComponent, Dropdown, CardModule, Button],
  templateUrl: './create-team.html',
  styleUrl: './create-team.scss',
})
export class CreateTeam implements OnInit {
  TeamDetailsForm!: FormGroup;
  userName: any;

  employeeRole = [
    { id: '1', name: 'Super user' },
    { id: '2', name: 'Manager' },
    { id: '3', name: 'Admin' },
    { id: '4', name: 'Employee' },
  ];
  submitted: boolean = false;

  get teamMembers(): FormArray {
    return this.TeamDetailsForm.get('teamMembers') as FormArray;
  }

  constructor(private fb: FormBuilder, private router: Router) {
    this.TeamDetailsForm = this.fb.group({
      teamMembers: this.fb.array([this.createTeamMember()]),
    });
  }

  ngOnInit(): void {
    this.getUserName();
  }

  getUserName() {
    let savedUser: any = sessionStorage.getItem('employeeDetails');
    const parsedData = JSON.parse(savedUser);
    this.userName = parsedData.name;
  }

  createTeamMember(): FormGroup {
    return this.fb.group({
      name: ['', [Validators.required]],
      role: ['', [Validators.required]],
    });
  }

  addMoreTeamMates(): void {
    this.teamMembers.push(this.createTeamMember());
  }

  removeTeamMate(index: number): void {
    if (this.teamMembers.length > 1) {
      this.teamMembers.removeAt(index);
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.TeamDetailsForm.valid) {
      this.router.navigate(['/login']);
      sessionStorage.removeItem('employeeDetails');
      sessionStorage.removeItem('businessDetails');
    } else {
      this.TeamDetailsForm.markAllAsDirty();
      this.TeamDetailsForm.updateValueAndValidity({ emitEvent: true });
    }
  }
}
